import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" style={{
    enableBackground: "new"
  }} id="svg7384" viewBox="0 0 16.009901 16.014242" width="1em" height="1em" {...props}><title id="title8473">{"Gnome Symbolic Icons"}</title><defs id="defs7386" /><g transform="translate(-191.9899,-552)" id="layer10" /><g transform="translate(-191.9899,-488)" id="layer1" /><g transform="translate(-191.9899,-552)" id="layer11" /><g transform="translate(-191.9899,-488)" id="layer7" /><g transform="translate(-191.9899,-488)" id="layer6" /><g transform="translate(-191.9899,-488)" id="layer5" /><g transform="translate(-191.9899,-488)" id="layer9" /><g transform="translate(-191.9899,-488)" id="layer2" /><g transform="translate(-191.9899,-488)" id="layer8" /><g transform="translate(-191.9899,-488)" id="layer3"><path id="path4042" d="m 200,490.5 a 2.5,2.5 0 0 1 -2.5,2.5 2.5,2.5 0 0 1 -2.5,-2.5 2.5,2.5 0 0 1 2.5,-2.5 2.5,2.5 0 0 1 2.5,2.5 z" style={{
        opacity: 1,
        fill: "#2e3436",
        fillOpacity: 1,
        stroke: "none",
        strokeWidth: 3.33333325,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: 4,
        strokeDasharray: "none",
        strokeDashoffset: 0,
        strokeOpacity: 1
      }} /><path id="rect4002" d="m 204.5,493 c 1.385,0 2.5,1.115 2.5,2.5 0,1.385 -1.115,2.5 -2.5,2.5 -1.385,0 -2.5,-1.115 -2.5,-2.5 0,-1.385 1.115,-2.5 2.5,-2.5 z" style={{
        opacity: 1,
        fill: "#2e3436",
        fillOpacity: 1,
        stroke: "none",
        strokeWidth: 3.33333325,
        strokeLinecap: "round",
        strokeLinejoin: "miter",
        strokeMiterlimit: 4,
        strokeDasharray: "none",
        strokeDashoffset: 0,
        strokeOpacity: 1
      }} /><path d="m 202,499 c -1.35232,-0.0191 -1.35232,2.01913 0,2 h 1 v 2 c -1.2e-4,0.77087 0.83516,1.25205 1.50195,0.86523 0.66593,0.38233 1.49645,-0.0974 1.49805,-0.86523 v -0.13477 c 0.86619,0.49882 1.8477,-0.44122 1.38672,-1.32812 l -0.90474,-1.72832 C 206.16814,499.2652 205.8993,499 205,499 h -1 z" id="path4048" style={{
        color: "#000000",
        fontStyle: "normal",
        fontVariant: "normal",
        fontWeight: "normal",
        fontStretch: "normal",
        fontSize: "medium",
        lineHeight: "normal",
        fontFamily: "sans-serif",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecoration: "none",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000000",
        letterSpacing: "normal",
        wordSpacing: "normal",
        textTransform: "none",
        writingMode: "lr-tb",
        direction: "ltr",
        textOrientation: "mixed",
        dominantBaseline: "auto",
        baselineShift: "baseline",
        textAnchor: "start",
        whiteSpace: "normal",
        shapePadding: 0,
        clipRule: "nonzero",
        display: "inline",
        overflow: "visible",
        visibility: "visible",
        opacity: 1,
        isolation: "auto",
        mixBlendMode: "normal",
        colorInterpolation: "sRGB",
        colorInterpolationFilters: "linearRGB",
        solidColor: "#000000",
        solidOpacity: 1,
        vectorEffect: "none",
        fill: "#2e3436",
        fillOpacity: 1,
        fillRule: "evenodd",
        stroke: "none",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "miter",
        strokeMiterlimit: 4,
        strokeDasharray: "none",
        strokeDashoffset: 0,
        strokeOpacity: 1,
        colorRendering: "auto",
        imageRendering: "auto",
        shapeRendering: "auto",
        textRendering: "auto",
        enableBackground: "accumulate"
      }} /><path id="path4051" d="m 196.5293,494.48633 a 1.0001,1.0001 0 0 0 -1.01953,0.87305 L 195,498.92969 V 503 a 1.0001,1.0001 0 1 0 2,0 v -3.92969 l 0.49023,-3.42969 a 1.0001,1.0001 0 0 0 -0.96093,-1.15429 z" style={{
        color: "#000000",
        fontStyle: "normal",
        fontVariant: "normal",
        fontWeight: "normal",
        fontStretch: "normal",
        fontSize: "medium",
        lineHeight: "normal",
        fontFamily: "sans-serif",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecoration: "none",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000000",
        letterSpacing: "normal",
        wordSpacing: "normal",
        textTransform: "none",
        writingMode: "lr-tb",
        direction: "ltr",
        textOrientation: "mixed",
        dominantBaseline: "auto",
        baselineShift: "baseline",
        textAnchor: "start",
        whiteSpace: "normal",
        shapePadding: 0,
        clipRule: "nonzero",
        display: "inline",
        overflow: "visible",
        visibility: "visible",
        opacity: 1,
        isolation: "auto",
        mixBlendMode: "normal",
        colorInterpolation: "sRGB",
        colorInterpolationFilters: "linearRGB",
        solidColor: "#000000",
        solidOpacity: 1,
        vectorEffect: "none",
        fill: "#2e3436",
        fillOpacity: 1,
        fillRule: "evenodd",
        stroke: "none",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "miter",
        strokeMiterlimit: 4,
        strokeDasharray: "none",
        strokeDashoffset: 0,
        strokeOpacity: 1,
        colorRendering: "auto",
        imageRendering: "auto",
        shapeRendering: "auto",
        textRendering: "auto",
        enableBackground: "accumulate"
      }} /><path id="path4053" d="m 198.54102,494.48633 a 1.0001,1.0001 0 0 0 -1.03125,1.15429 L 198,499.07031 V 503 a 1.0001,1.0001 0 1 0 2,0 v -4.07031 l -0.50977,-3.57031 a 1.0001,1.0001 0 0 0 -0.94921,-0.87305 z" style={{
        color: "#000000",
        fontStyle: "normal",
        fontVariant: "normal",
        fontWeight: "normal",
        fontStretch: "normal",
        fontSize: "medium",
        lineHeight: "normal",
        fontFamily: "sans-serif",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecoration: "none",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000000",
        letterSpacing: "normal",
        wordSpacing: "normal",
        textTransform: "none",
        writingMode: "lr-tb",
        direction: "ltr",
        textOrientation: "mixed",
        dominantBaseline: "auto",
        baselineShift: "baseline",
        textAnchor: "start",
        whiteSpace: "normal",
        shapePadding: 0,
        clipRule: "nonzero",
        display: "inline",
        overflow: "visible",
        visibility: "visible",
        opacity: 1,
        isolation: "auto",
        mixBlendMode: "normal",
        colorInterpolation: "sRGB",
        colorInterpolationFilters: "linearRGB",
        solidColor: "#000000",
        solidOpacity: 1,
        vectorEffect: "none",
        fill: "#2e3436",
        fillOpacity: 1,
        fillRule: "evenodd",
        stroke: "none",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "miter",
        strokeMiterlimit: 4,
        strokeDasharray: "none",
        strokeDashoffset: 0,
        strokeOpacity: 1,
        colorRendering: "auto",
        imageRendering: "auto",
        shapeRendering: "auto",
        textRendering: "auto",
        enableBackground: "accumulate"
      }} /><path d="m 196,495 h 3 v 7 h -1 v -1.5 c 0,0 0,-0.5 -0.5,-0.5 -0.5,0 -0.5,0.5 -0.5,0.5 v 1.5 h -1 z" id="path4055" style={{
        opacity: 1,
        fill: "#2e3436",
        fillOpacity: 1,
        stroke: "none",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "miter",
        strokeMiterlimit: 4,
        strokeDasharray: "none",
        strokeDashoffset: 0,
        strokeOpacity: 1
      }} /><path id="path4057" d="m 196,494 a 1.0001,1.0001 0 0 0 -0.70703,0.29297 l -3,3 a 1.0001,1.0001 0 1 0 1.41406,1.41406 L 196.41406,496 h 1.93555 l 1.73633,3.90625 a 1.0002723,1.0002723 0 1 0 1.82812,-0.8125 l -2,-4.5 A 1.0001,1.0001 0 0 0 199,494 Z" style={{
        color: "#000000",
        fontStyle: "normal",
        fontVariant: "normal",
        fontWeight: "normal",
        fontStretch: "normal",
        fontSize: "medium",
        lineHeight: "normal",
        fontFamily: "sans-serif",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecoration: "none",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000000",
        letterSpacing: "normal",
        wordSpacing: "normal",
        textTransform: "none",
        writingMode: "lr-tb",
        direction: "ltr",
        textOrientation: "mixed",
        dominantBaseline: "auto",
        baselineShift: "baseline",
        textAnchor: "start",
        whiteSpace: "normal",
        shapePadding: 0,
        clipRule: "nonzero",
        display: "inline",
        overflow: "visible",
        visibility: "visible",
        opacity: 1,
        isolation: "auto",
        mixBlendMode: "normal",
        colorInterpolation: "sRGB",
        colorInterpolationFilters: "linearRGB",
        solidColor: "#000000",
        solidOpacity: 1,
        vectorEffect: "none",
        fill: "#2e3436",
        fillOpacity: 1,
        fillRule: "evenodd",
        stroke: "none",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: 4,
        strokeDasharray: "none",
        strokeDashoffset: 0,
        strokeOpacity: 1,
        colorRendering: "auto",
        imageRendering: "auto",
        shapeRendering: "auto",
        textRendering: "auto",
        enableBackground: "accumulate"
      }} /></g><g transform="translate(-191.9899,-488)" id="layer4" /></svg>;
}

export default SvgComponent;